// extracted by mini-css-extract-plugin
export default {"buttons":"Profile_buttons__ZbV77","rounded-circle":"Profile_rounded-circle__jIeo5"};